import Vue from 'vue'

const state = {
	accept_terms_and_conditions: '',
	access_token: '',
	admin_left_menu: false,
	email: '',
	full_name: '',
	has_mandatory_surveys: false,
	id: '',
	id_user_client_country_selected: '',
	id_user_client_profile: '',
	id_user_client_selected: '',
	id_user_language_selected: '',
	is_superuser: false,
	left_menu: false,
	refresh_token: '',
	reload_content: false,
	right_menu: false,
	user_branches: [],
	user_change_password: false,
	user_client_module_items: [],
	user_clients: [],
	user_companies: [],
	user_countries: [],
	user_document: '',
	user_firebase_document: '',
	user_firebase_document_ranking_areas: [],
	user_firebase_token: '',
	webservice_token: '',
	courses_report_button_delay: 0,
	appointments_report_button_delay: 0,
	trails_report_button_delay: 0,
	webcasts_report_button_delay: 0,
	podcasts_report_button_delay: 0,
	users_report_button_delay: 0,
	libraries_report_button_delay: 0,
	live_classes_report_button_delay: 0,
	mailing_report_button_delay: 0,
}

const actions = {
	SET_ACCESS_TOKEN(context, [access_token, refresh_token, user_firebase_token]) {
		context.commit('SAVE_ACCESS_TOKEN', [access_token, refresh_token, user_firebase_token])
	},

	SET_USER_DATA(
		context,
		[
			id,
			id_user_client_profile,
			full_name,
			user_document,
			id_user_client_selected,
			id_user_client_country_selected,
			id_user_language_selected,
			user_clients,
			user_client_module_items,
			user_firebase_document,
			is_superuser,
			email,
			user_firebase_document_ranking_areas,
			has_mandatory_surveys,
			accept_terms_and_conditions,
			user_companies,
			user_branches,
		]
	) {
		context.commit('SAVE_USER_DATA', [
			id,
			id_user_client_profile,
			full_name,
			user_document,
			id_user_client_selected,
			id_user_client_country_selected,
			id_user_language_selected,
			user_clients,
			user_client_module_items,
			user_firebase_document,
			is_superuser,
			email,
			user_firebase_document_ranking_areas,
			has_mandatory_surveys,
			accept_terms_and_conditions,
			user_companies,
			user_branches,
		])
	},

	SET_USER_COUNTRIES(context, [user_countries]) {
		context.commit('SAVE_USER_COUNTRIES', [user_countries])
	},

	SET_RELOAD_CONTENT(context, [reload_content]) {
		context.commit('SAVE_RELOAD_CONTENT', [reload_content])
	},

	SET_CLIENT(context, [id_user_client_selected]) {
		context.commit('SAVE_CLIENT', [id_user_client_selected])
	},

	SET_COUNTRY(context, [id_user_client_country_selected]) {
		context.commit('SAVE_COUNTRY', [id_user_client_country_selected])
	},

	SET_LANGUAGE(context, [id_user_language_selected]) {
		context.commit('SAVE_LANGUAGE', [parseInt(id_user_language_selected)])
	},

	SET_LEFT_MENU(context, [left_menu]) {
		context.commit('SAVE_LEFT_MENU', [left_menu])
	},

	SET_RIGHT_MENU(context, [right_menu]) {
		context.commit('SAVE_RIGHT_MENU', [right_menu])
	},

	SET_ADMIN_LEFT_MENU(context, [admin_left_menu]) {
		context.commit('SAVE_ADMIN_LEFT_MENU', [admin_left_menu])
	},

	SET_MANDATORY_SURVEYS(context, [has_mandatory_surveys]) {
		context.commit('SAVE_MANDATORY_SURVEYS', [has_mandatory_surveys])
	},

	SET_WEBSERVICE_TOKEN(context, [webservice_token]) {
		context.commit('SAVE_WEBSERVICE_TOKEN', [webservice_token])
	},

	SET_TERMS_AND_CONDITIONS(context, [accept_terms_and_conditions]) {
		context.commit('SAVE_TERMS_AND_CONDITIONS', [accept_terms_and_conditions])
	},

	SET_USER_CHANGE_PASSWORD(context, [user_change_password]) {
		context.commit('SAVE_USER_CHANGE_PASSWORD', [user_change_password])
	},

	SET_COURSES_REPORT_BUTTON_DELAY(context, [courses_report_button_delay]) {
		context.commit('SAVE_COURSES_REPORT_BUTTON_DELAY', [courses_report_button_delay])
	},

	SET_APPOINTMENTS_REPORT_BUTTON_DELAY(context, [appointments_report_button_delay]) {
		context.commit('SAVE_APPOINTMENTS_REPORT_BUTTON_DELAY', [appointments_report_button_delay])
	},

	SET_TRAILS_REPORT_BUTTON_DELAY(context, [trails_report_button_delay]) {
		context.commit('SAVE_TRAILS_REPORT_BUTTON_DELAY', [trails_report_button_delay])
	},

	SET_WEBCASTS_REPORT_BUTTON_DELAY(context, [webcasts_report_button_delay]) {
		context.commit('SAVE_WEBCASTS_REPORT_BUTTON_DELAY', [webcasts_report_button_delay])
	},

	SET_PODCASTS_REPORT_BUTTON_DELAY(context, [podcasts_report_button_delay]) {
		context.commit('SAVE_PODCASTS_REPORT_BUTTON_DELAY', [podcasts_report_button_delay])
	},

	SET_USERS_REPORT_BUTTON_DELAY(context, [users_report_button_delay]) {
		context.commit('SAVE_USERS_REPORT_BUTTON_DELAY', [users_report_button_delay])
	},

	SET_LIBRARIES_REPORT_BUTTON_DELAY(context, [libraries_report_button_delay]) {
		context.commit('SAVE_LIBRARIES_REPORT_BUTTON_DELAY', [libraries_report_button_delay])
	},

	SET_LIVE_CLASSES_REPORT_BUTTON_DELAY(context, [live_classes_report_button_delay]) {
		context.commit('SAVE_LIVE_CLASSES_REPORT_BUTTON_DELAY', [live_classes_report_button_delay])
	},

	SET_MAILING_REPORT_BUTTON_DELAY(context, [mailing_report_button_delay]) {
		context.commit('SET_MAILING_REPORT_BUTTON_DELAY', [mailing_report_button_delay])
	},
}

const mutations = {
	SAVE_ACCESS_TOKEN: (state, [access_token, refresh_token, user_firebase_token]) => {
		Vue.set(state, 'access_token', access_token)
		Vue.set(state, 'refresh_token', refresh_token)
		Vue.set(state, 'user_firebase_token', user_firebase_token)
	},

	SAVE_USER_DATA: (
		state,
		[
			id,
			id_user_client_profile,
			full_name,
			user_document,
			id_user_client_selected,
			id_user_client_country_selected,
			id_user_language_selected,
			user_clients,
			user_client_module_items,
			user_firebase_document,
			is_superuser,
			email,
			user_firebase_document_ranking_areas,
			has_mandatory_surveys,
			accept_terms_and_conditions,
			user_companies,
			user_branches,
		]
	) => {
		Vue.set(state, 'id', id)
		Vue.set(state, 'id_user_client_profile', id_user_client_profile)
		Vue.set(state, 'full_name', full_name)
		Vue.set(state, 'user_document', user_document)
		Vue.set(state, 'id_user_client_selected', id_user_client_selected)
		Vue.set(state, 'id_user_client_country_selected', id_user_client_country_selected)
		Vue.set(
			state,
			'id_user_language_selected',
			id_user_language_selected ? id_user_language_selected : state.id_user_language_selected
		)
		Vue.set(state, 'user_clients', user_clients)
		Vue.set(state, 'user_client_module_items', user_client_module_items)
		Vue.set(state, 'user_firebase_document', user_firebase_document)
		Vue.set(state, 'user_firebase_document_ranking_areas', user_firebase_document_ranking_areas)
		Vue.set(state, 'is_superuser', is_superuser)
		Vue.set(state, 'email', email)
		Vue.set(state, 'has_mandatory_surveys', has_mandatory_surveys)
		Vue.set(state, 'accept_terms_and_conditions', accept_terms_and_conditions)
		Vue.set(state, 'user_companies', user_companies)
		Vue.set(state, 'user_branches', user_branches)
	},

	SAVE_USER_COUNTRIES: (state, [user_countries]) => {
		Vue.set(state, 'user_countries', user_countries)
	},

	SAVE_RELOAD_CONTENT: (state, [reload_content]) => {
		Vue.set(state, 'reload_content', reload_content)
	},

	SAVE_CLIENT: (state, [id_user_client_selected]) => {
		Vue.set(state, 'id_user_client_selected', id_user_client_selected)
	},

	SAVE_COUNTRY: (state, [id_user_client_country_selected]) => {
		Vue.set(state, 'id_user_client_country_selected', id_user_client_country_selected)
	},

	SAVE_LANGUAGE: (state, [id_user_language_selected]) => {
		Vue.set(state, 'id_user_language_selected', id_user_language_selected)
	},

	SAVE_LEFT_MENU: (state, [left_menu]) => {
		Vue.set(state, 'left_menu', left_menu)
	},

	SAVE_RIGHT_MENU: (state, [right_menu]) => {
		Vue.set(state, 'right_menu', right_menu)
	},

	SAVE_ADMIN_LEFT_MENU: (state, [admin_left_menu]) => {
		Vue.set(state, 'admin_left_menu', admin_left_menu)
	},

	SAVE_MANDATORY_SURVEYS: (state, [has_mandatory_surveys]) => {
		Vue.set(state, 'has_mandatory_surveys', has_mandatory_surveys)
	},

	SAVE_WEBSERVICE_TOKEN: (state, [webservice_token]) => {
		Vue.set(state, 'webservice_token', webservice_token)
	},

	SAVE_TERMS_AND_CONDITIONS: (state, [accept_terms_and_conditions]) => {
		Vue.set(state, 'accept_terms_and_conditions', accept_terms_and_conditions)
	},

	SAVE_USER_CHANGE_PASSWORD: (state, [user_change_password]) => {
		Vue.set(state, 'user_change_password', user_change_password)
	},
	SAVE_COURSES_REPORT_BUTTON_DELAY: (state, [courses_report_button_delay]) => {
		Vue.set(state, 'courses_report_button_delay', courses_report_button_delay)
	},
	SAVE_APPOINTMENTS_REPORT_BUTTON_DELAY: (state, [appointments_report_button_delay]) => {
		Vue.set(state, 'appointments_report_button_delay', appointments_report_button_delay)
	},
	SAVE_TRAILS_REPORT_BUTTON_DELAY: (state, [trails_report_button_delay]) => {
		Vue.set(state, 'trails_report_button_delay', trails_report_button_delay)
	},
	SAVE_WEBCASTS_REPORT_BUTTON_DELAY: (state, [webcasts_report_button_delay]) => {
		Vue.set(state, 'webcasts_report_button_delay', webcasts_report_button_delay)
	},
	SAVE_PODCASTS_REPORT_BUTTON_DELAY: (state, [podcasts_report_button_delay]) => {
		Vue.set(state, 'podcasts_report_button_delay', podcasts_report_button_delay)
	},
	SAVE_USERS_REPORT_BUTTON_DELAY: (state, [users_report_button_delay]) => {
		Vue.set(state, 'users_report_button_delay', users_report_button_delay)
	},
	SAVE_LIBRARIES_REPORT_BUTTON_DELAY: (state, [libraries_report_button_delay]) => {
		Vue.set(state, 'libraries_report_button_delay', libraries_report_button_delay)
	},
	SAVE_LIVE_CLASSES_REPORT_BUTTON_DELAY: (state, [live_classes_report_button_delay]) => {
		Vue.set(state, 'live_classes_report_button_delay', live_classes_report_button_delay)
	},
	SAVE_MAILING_REPORT_BUTTON_DELAY: (state, [mailing_report_button_delay]) => {
		Vue.set(state, 'mailing_report_button_delay', mailing_report_button_delay)
	},
}

const getters = {
	accept_terms_and_conditions: (state) => {
		return state.accept_terms_and_conditions
	},

	access_token: (state) => {
		return state.access_token
	},

	refresh_token: (state) => {
		return state.refresh_token
	},

	user_firebase_token: (state) => {
		return state.user_firebase_token
	},

	id: (state) => {
		return state.id
	},

	id_user_client_profile: (state) => {
		return state.id_user_client_profile
	},

	full_name: (state) => {
		return state.full_name
	},

	user_document: (state) => {
		return state.user_document
	},

	id_user_client_selected: (state) => {
		return state.id_user_client_selected
	},

	id_user_client_country_selected: (state) => {
		return state.id_user_client_country_selected
	},

	id_user_language_selected: (state) => {
		return state.id_user_language_selected
	},

	reload_content: (state) => {
		return state.reload_content
	},

	user_clients: (state) => {
		return state.user_clients.sort((a, b) => {
			return a.name.trim() === b.name.trim() ? 0 : a.name.trim() < b.name.trim() ? -1 : 1
		})
	},

	user_module_items: (state) => {
		const obj = state.user_client_module_items.find(
			(obj) => obj.id == state.id_user_client_selected
		)
		return obj ? obj.module_items : []
	},

	user_client_module_items: (state) => {
		return state.user_client_module_items
	},

	left_menu: (state) => {
		return state.left_menu
	},

	right_menu: (state) => {
		return state.right_menu
	},

	admin_left_menu: (state) => {
		return state.admin_left_menu
	},

	user_firebase_document: (state) => {
		return state.user_firebase_document
	},

	user_firebase_document_ranking_areas: (state) => {
		return state.user_firebase_document_ranking_areas
	},

	is_superuser: (state) => {
		return state.is_superuser
	},

	email: (state) => {
		return state.email
	},

	has_mandatory_surveys: (state) => {
		return state.has_mandatory_surveys
	},

	user_countries: (state) => {
		return state.user_countries
	},

	webservice_token: (state) => {
		return state.webservice_token
	},

	user_change_password: (state) => {
		return state.user_change_password
	},

	user_companies: (state) => {
		return state.user_companies
	},

	user_branches: (state) => {
		return state.user_branches
	},

	courses_report_button_delay: (state) => {
		return state.courses_report_button_delay
	},
	appointments_report_button_delay: (state) => {
		return state.appointments_report_button_delay
	},
	trails_report_button_delay: (state) => {
		return state.trails_report_button_delay
	},
	webcasts_report_button_delay: (state) => {
		return state.webcasts_report_button_delay
	},
	podcasts_report_button_delay: (state) => {
		return state.podcasts_report_button_delay
	},
	users_report_button_delay: (state) => {
		return state.users_report_button_delay
	},
	libraries_report_button_delay: (state) => {
		return state.libraries_report_button_delay
	},
	live_classes_report_button_delay: (state) => {
		return state.live_classes_report_button_delay
	},
	mailing_report_button_delay: (state) => {
		return state.mailing_report_button_delay
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
